import React from 'react'

const NotFoundPage = () => {
  return <div>404, Page not Found.</div>
}

export default NotFoundPage
